<template>
  <div>
    <section class="intro container">


      <h2 class="text-center">Welcome to Shamal Communications!</h2>
      <div class="txt">
        <p>Established in 2004, Shamal Communications is a leading independent, full service public relations
          consultancy based in Dubai.</p>
        <p>As a bespoke boutique agency, we effectively manage market perceptions by working hand-in-hand with our
          clients, to build a positive, informed opinion among their target audiences.</p>
        <p>We deliver strategic, focused, creative and cost-effective English-Arabic communications’ solutions that
          enable our clients to successfully position their businesses and brands, whether in a corporate or consumer
          environment. Our work helps enhance their visibility in a highly competitive and rapidly changing, digital
          marketplace.</p>
        <p>We work across a broad spectrum of industry sectors, with media reach across the GCC and the wider region, as
          well as offering international exposure in over 30 countries through our global network of partner agencies.</p>
        <p>Our team of dedicated, public relations professionals has direct experience and an in-depth understanding of
          the region’s media landscape and are committed to consistently developing brands in a dynamic, credible and
          trustworthy fashion.</p>
        <p>

        </p>



      </div>


    </section>
  </div>
</template>
<script>
export default {
  props: []
}
</script>
<style scoped>
section.intro {
  background: #fff;
  padding: 20px;
  margin-bottom: 3px;
}

section h2 {
  margin: 30px 0 30px;
}

.signature {
  margin: 10px 0;
}

section .txt {
  max-width: 800px;
  margin: auto;
  width: 90%;
}


.tools > div {
  flex: 0 0 33.33%;
  max-width: 33.33%;
  padding: 30px;
}

.tools > div > span {
  font-size: 70px;
  color: #A7975F;
}

.tools > div h4 {
  font-size: 16px;
  color: var(--greedv);
  font-weight: 700;

}


</style>